import { DatePickerInput } from "@mantine/dates";
import "dayjs/locale/tr";
import styled from "styled-components";
import { theme } from "../../../theme";
import { CalendarIcon } from "@heroicons/react/16/solid";

const CustomDatePicker = ({
  locale = "tr",
  w = 200,
  clearable = true,
  highlightToday = true,
  withAsterisk = false,
  leftSection,
  h = 44,
  ...rest
}: any) => {
  return (
    <StyledDatePickerInput
      w={w}
      $height={h}
      locale={locale}
      clearable={clearable}
      highlightToday={highlightToday}
      withAsterisk={withAsterisk}
      leftSectionPointerEvents="none"
      leftSection={
        leftSection ?? (
          <CalendarIcon
            height={24}
            style={{ color: theme.colors.brand.normal }}
          />
        )
      }
      {...rest}
    />
  );
};

export default CustomDatePicker;

const StyledDatePickerInput = styled(DatePickerInput)<{ $height: any }>`
  .mantine-DatePickerInput-input {
    height: ${({ $height }) => $height}px;
  }

  .mantine-DatePickerInput-input[aria-expanded="true"] {
    border-color: ${theme.colors.brand.normal};
    box-shadow: 0px 0px 5px 3px #5c26ff14;
  }
`;
